import axios from 'axios';

export function getPortfolioAlerts(portfolioId, startDate, endDate, config) {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        'x-location-id': localStorage.getItem('locationId')
    };

    const url = `${config.getPortfolioAlerts}?portfolioId=${portfolioId}&startDate=${startDate}&endDate=${endDate}`;
    // console.log(url);
    // console.log(axios.defaults.common);
    return dispatch => dispatch({
        type: 'PORTFOLIO_ALERTS_FETCH',
        payload: axios({ method: 'get', url, headers })
    }).catch((error) => {
        console.log(error);
    });
}

export function clearPortfolioAlerts() {
    return {
        type: 'PORTFOLIO_ALERTS_CLEAR',
        payload: ''
    };
}


// WEBPACK FOOTER //
// ./src/actions/getPortfolioAlerts.js